"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = exports.Experimental = exports.watchStaticFile = exports.useCurrentScale = exports.useCurrentFrame = exports.useBufferState = exports.staticFile = exports.Series = exports.Sequence = exports.registerRoot = exports.prefetch = exports.random = exports.interpolate = exports.Loop = exports.interpolateColors = exports.Img = exports.getStaticFiles = exports.getRemotionEnvironment = exports.delayRender = exports.continueRender = exports.getInputProps = exports.Composition = exports.cancelRender = exports.Artifact = void 0;
require("./_check-rsc.js");
require("./asset-types.js");
const Clipper_js_1 = require("./Clipper.js");
const enable_sequence_stack_traces_js_1 = require("./enable-sequence-stack-traces.js");
const is_player_js_1 = require("./is-player.js");
const multiple_versions_warning_js_1 = require("./multiple-versions-warning.js");
const Null_js_1 = require("./Null.js");
const Sequence_js_1 = require("./Sequence.js");
(0, multiple_versions_warning_js_1.checkMultipleRemotionVersions)();
__exportStar(require("./AbsoluteFill.js"), exports);
__exportStar(require("./animated-image/index.js"), exports);
var Artifact_js_1 = require("./Artifact.js");
Object.defineProperty(exports, "Artifact", { enumerable: true, get: function () { return Artifact_js_1.Artifact; } });
__exportStar(require("./audio/index.js"), exports);
var cancel_render_js_1 = require("./cancel-render.js");
Object.defineProperty(exports, "cancelRender", { enumerable: true, get: function () { return cancel_render_js_1.cancelRender; } });
var Composition_js_1 = require("./Composition.js");
Object.defineProperty(exports, "Composition", { enumerable: true, get: function () { return Composition_js_1.Composition; } });
var input_props_js_1 = require("./config/input-props.js");
Object.defineProperty(exports, "getInputProps", { enumerable: true, get: function () { return input_props_js_1.getInputProps; } });
var delay_render_js_1 = require("./delay-render.js");
Object.defineProperty(exports, "continueRender", { enumerable: true, get: function () { return delay_render_js_1.continueRender; } });
Object.defineProperty(exports, "delayRender", { enumerable: true, get: function () { return delay_render_js_1.delayRender; } });
__exportStar(require("./easing.js"), exports);
__exportStar(require("./Folder.js"), exports);
__exportStar(require("./freeze.js"), exports);
var get_remotion_environment_js_1 = require("./get-remotion-environment.js");
Object.defineProperty(exports, "getRemotionEnvironment", { enumerable: true, get: function () { return get_remotion_environment_js_1.getRemotionEnvironment; } });
var get_static_files_js_1 = require("./get-static-files.js");
Object.defineProperty(exports, "getStaticFiles", { enumerable: true, get: function () { return get_static_files_js_1.getStaticFiles; } });
__exportStar(require("./IFrame.js"), exports);
var Img_js_1 = require("./Img.js");
Object.defineProperty(exports, "Img", { enumerable: true, get: function () { return Img_js_1.Img; } });
__exportStar(require("./internals.js"), exports);
var interpolate_colors_js_1 = require("./interpolate-colors.js");
Object.defineProperty(exports, "interpolateColors", { enumerable: true, get: function () { return interpolate_colors_js_1.interpolateColors; } });
var index_js_1 = require("./loop/index.js");
Object.defineProperty(exports, "Loop", { enumerable: true, get: function () { return index_js_1.Loop; } });
var no_react_1 = require("./no-react");
Object.defineProperty(exports, "interpolate", { enumerable: true, get: function () { return no_react_1.interpolate; } });
Object.defineProperty(exports, "random", { enumerable: true, get: function () { return no_react_1.random; } });
var prefetch_js_1 = require("./prefetch.js");
Object.defineProperty(exports, "prefetch", { enumerable: true, get: function () { return prefetch_js_1.prefetch; } });
var register_root_js_1 = require("./register-root.js");
Object.defineProperty(exports, "registerRoot", { enumerable: true, get: function () { return register_root_js_1.registerRoot; } });
var Sequence_js_2 = require("./Sequence.js");
Object.defineProperty(exports, "Sequence", { enumerable: true, get: function () { return Sequence_js_2.Sequence; } });
var index_js_2 = require("./series/index.js");
Object.defineProperty(exports, "Series", { enumerable: true, get: function () { return index_js_2.Series; } });
__exportStar(require("./spring/index.js"), exports);
var static_file_js_1 = require("./static-file.js");
Object.defineProperty(exports, "staticFile", { enumerable: true, get: function () { return static_file_js_1.staticFile; } });
__exportStar(require("./Still.js"), exports);
var use_buffer_state_1 = require("./use-buffer-state");
Object.defineProperty(exports, "useBufferState", { enumerable: true, get: function () { return use_buffer_state_1.useBufferState; } });
var use_current_frame_js_1 = require("./use-current-frame.js");
Object.defineProperty(exports, "useCurrentFrame", { enumerable: true, get: function () { return use_current_frame_js_1.useCurrentFrame; } });
var use_current_scale_1 = require("./use-current-scale");
Object.defineProperty(exports, "useCurrentScale", { enumerable: true, get: function () { return use_current_scale_1.useCurrentScale; } });
__exportStar(require("./use-video-config.js"), exports);
__exportStar(require("./version.js"), exports);
__exportStar(require("./video-config.js"), exports);
__exportStar(require("./video/index.js"), exports);
var watch_static_file_js_1 = require("./watch-static-file.js");
Object.defineProperty(exports, "watchStaticFile", { enumerable: true, get: function () { return watch_static_file_js_1.watchStaticFile; } });
exports.Experimental = {
    /**
     * @description This is a special component that will cause Remotion to only partially capture the frame of the video.
     * @see [Documentation](https://www.remotion.dev/docs/clipper)
     */
    Clipper: Clipper_js_1.Clipper,
    /**
     * @description This is a special component, that, when rendered, will skip rendering the frame altogether.
     * @see [Documentation](https://www.remotion.dev/docs/null)
     */
    Null: Null_js_1.Null,
    useIsPlayer: is_player_js_1.useIsPlayer,
};
const proxyObj = {};
exports.Config = new Proxy(proxyObj, {
    get(_, prop) {
        if (prop === 'Bundling' ||
            prop === 'Rendering' ||
            prop === 'Log' ||
            prop === 'Puppeteer' ||
            prop === 'Output') {
            return exports.Config;
        }
        return () => {
            /* eslint-disable no-console */
            console.warn('⚠️  The CLI configuration has been extracted from Remotion Core.');
            console.warn('Update the import from the config file:');
            console.warn();
            console.warn('- Delete:');
            console.warn('import {Config} from "remotion";');
            console.warn('+ Replace:');
            console.warn('import {Config} from "@remotion/cli/config";');
            console.warn();
            console.warn('For more information, see https://www.remotion.dev/docs/4-0-migration.');
            /* eslint-enable no-console */
            process.exit(1);
        };
    },
});
(0, enable_sequence_stack_traces_js_1.addSequenceStackTraces)(Sequence_js_1.Sequence);
